import FormPaperLayout, { type FormPaperLayoutProps } from "./FormPaperLayout";
export default FormPaperLayout;
export { type FormPaperLayoutProps };
